import { Observable } from 'rxjs'

export abstract class TempidcardGateway {
    abstract DownloadPDF(ParentName: string, SectionName: string): Observable<any>
    abstract streamPDF(parent: string, section: string): Observable<any>
}
